export const APP_CONFIGS = {
   APP_TYPE: {
      WEB_ADMIN: '1',
      WEB_ORDER: '2'
   }
}

// eslint-disable-next-line no-useless-escape
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]).+$/;
export const PASSWORD_MIN_LENGTH = 10;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/